import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';
import { DemandeIntervention } from '@/models/DemandeIntervention';
import { FilterDemandeIntervention } from '@/modules/DemandeIntervention/services/DemandeInterventionService';

class InterventionService {
    public async sendAskIntervention(demandeIntervention: DemandeIntervention, documents: File[]): Promise<any> {
        const formData = new FormData();

        const transformToBlobJson = (data: any) => new Blob([JSON.stringify(data)], { type: 'application/json' });

        formData.set('demandeIntervention', transformToBlobJson(demandeIntervention));

        const fileToBlob = async (file: File): Promise<Blob> => {
            return new Promise(resolve => {
                const reader = new FileReader();
                reader.onloadend = () => reader.readAsBinaryString(file);
                resolve(file);
            });
        };

        await Promise.all(
            documents.map(async (file: File) => {
                const blob = await fileToBlob(file);
                formData.append('piecesJointes', blob, file.name);
            })
        );

        return await http.post(Routes.InterventionRoutes.PostAskIntervention(), formData);
    }

    public async getNonPreventiveInterventionList(params: FilterDemandeIntervention): Promise<any> {
        return http.get(Routes.InterventionRoutes.GetNonPreventiveInterventionList(), { params: { ...params } });
    }

    public async getOneNonPreventiveIntervention(id: number): Promise<any> {
        return await http.get(Routes.InterventionRoutes.GetOneInterventions(id));
    }
}

export default new InterventionService();
